export enum DatasetTypeEnum {
  AGE = 'age',
  BOOK_READ = 'book_read_count',
  CLIL = 'clil',
  MOST_FREQUENT = 'most_frequent',
  OVERREPRESENTED = 'overrepresented',
  WORKS_MIRROR = 'works_mirror',
  AUTHORS_MIRROR = 'authors_mirror',
}
